import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { procedureActionTypes } from '../reducer';

function* getRecentProcedures() {
  yield requestSaga({
    actionType: procedureActionTypes.getRecentProceduresList,
    request: dataProvider.getList,
    resource: resources.physician.recentProcedures,
  });
}

export default getRecentProcedures;
